function UsersControls() {
    "use strict";

    this.CardView = null;
    this.CardViewFilter = null;
    this.CardViewPaginator = null;

    this.ProfileValidator = null;
}
if (typeof exports !== 'undefined') {
    module.exports = UsersControls;
}